import { FieldCondition, PartialCondition } from "../types";

export default (condition: PartialCondition): condition is FieldCondition => {
  return !!condition.field && !!condition.operator && !!condition.values;
};
